import { render, staticRenderFns } from "./MapEditor.vue?vue&type=template&id=bf776556&scoped=true"
import script from "./MapEditor.vue?vue&type=script&lang=js"
export * from "./MapEditor.vue?vue&type=script&lang=js"
import style0 from "./MapEditor.vue?vue&type=style&index=0&id=bf776556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf776556",
  null
  
)

export default component.exports